import {
  getOperationDetail,
  getOperations,
  getOperationsPeriods,
} from '@/common/integrations/menhir/employee/operations/operations.service';
import {
  IGetOperationsParams,
  IOperation,
  IOperationItem,
  TGetOperationsPeriodsParams,
  TOperationPeriod,
} from '@/common/integrations/menhir/employee/operations/operations.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { PaginationResponse } from '@/common/types/general';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

export function useGetOperationsPeriods(
  params: TGetOperationsPeriodsParams = {},
  options?: UseQueryOptions<PaginationResponse<TOperationPeriod>>
) {
  const { data: periods, ...rest } = useQuery({
    queryKey: [
      MENHIR_ENDPOINTS.EMPLOYEE.OPERATIONS.PERIODS,
      JSON.stringify(params),
    ],
    queryFn: () => getOperationsPeriods(params),
    ...options,
  });

  return { periods, ...rest };
}

export function useGetOperations(
  params: IGetOperationsParams = {},
  options?: UseQueryOptions<PaginationResponse<IOperationItem>>
) {
  const { data: operations, ...rest } = useQuery<
    PaginationResponse<IOperationItem>
  >({
    queryKey: [
      MENHIR_ENDPOINTS.EMPLOYEE.OPERATIONS.ROOT,
      JSON.stringify(params),
    ],
    queryFn: () => getOperations(params),
    ...options,
  });

  return {
    operations,
    ...rest,
  };
}

export const useGetOperationDetail = (
  id: string,
  options?: UseQueryOptions<IOperation>
) => {
  const { data: operation, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.OPERATIONS.DETAIL, id],
    queryFn: () => getOperationDetail(id),
    ...options,
  });
  return { operation, ...rest };
};
